import useApi from '../../../services/useApi'

export const useGetClassificationsDropdown = () => {
  const Api = useApi()

  const {data: response, isFetching} = Api.useGetQuery(
    '/analytics/profitability/filters/classifications'
  )

  return {
    classifications: response?.data || [],
    isLoading: isFetching,
  }
}
